import { singleton } from "tsyringe";
import SubscriptionPlanResponseResource from "common/resources/SubscriptionPlan/SubscriptionPlanResponseResource";
import BaseApi from "../BaseApi";

@singleton()
export default class SubscriptionPlanApi extends BaseApi {
	private baseurl = `${this.apiUrl}/subscription-plans`;

	public async getSubscriptionPlan(userId: string): Promise<SubscriptionPlanResponseResource> {
		return this.getRequest<SubscriptionPlanResponseResource>(`${this.baseurl}/${userId}`);
	}
}
